export default "__VITE_ASSET__D0y$irs$__"